import { QueryClient, QueryClientProvider, QueryCache, MutationCache } from '@tanstack/react-query';
import { type ReactNode } from 'react';
import { telemetryService } from '@/services/telemetryService';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: 1,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      telemetryService.trackException(error, {
        type: 'query',
        queryKey: JSON.stringify(query.queryKey?.slice(0, 2)),
      });
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      telemetryService.trackException(error, {
        type: 'mutation',
        mutationKey: mutation.options.mutationKey ? JSON.stringify(mutation.options.mutationKey) : 'unknown',
      });
    },
  }),
});

type QueryProviderProps = {
  children: ReactNode;
};

export const QueryProvider = ({ children }: QueryProviderProps) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
